<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
       <v-card-text>
        <template v-for="step in strategy.getSteps()">
          <component
             :is="'v-step-generator'"
             v-model=step.model
             v-bind="step.props"
             >
          </component>
        </template>
      </v-card-text>
    </v-form>
    <template #actions>
      <v-btn v-show="!isNew" :disabled='!valid' @click="save">Сохранить</v-btn>
      <v-btn v-show="!isNew" @click="remove">Удалить</v-btn>
      <v-btn v-show="isNew" :disabled='!valid' @click="add">Добавить</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="!isNew" @click="createNew">Новый</v-btn>
    </template>
   </v-btn-form> 
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import vStepGenerator from '../assist/StepGenerator.vue'
  // import people from './index.js'
  import AssistClasses from '../assist/AssistClasses.js'
  import vBtnForm from '../common/BtnForm'

  class Strategy extends AssistClasses.Strategy {
    getTypeCode () {
      return ''
    }
    getTypeName () {
      return ''
    }
    setContext (cxt) {
      this.context = cxt
    }
    createModel () {
      var model = new AssistClasses.Model()
      return model
    }
    createDefaultModel (individual) {
      return this.createModel()
    }
    createModelFromData (data) {
      return this.createModel()
    }
    updateSteps (scheme) {
      return this
    }
    updateModel (model) {
    }
    fetchData (itemId) {
      return new Promise((resolve, reject) => resolve(null))
    }
    updateData (itemId, model) {
      return new Promise((resolve, reject) => resolve(itemId))
    }
    viewTitle (model) {
      return ''
    }
  }

  export default {
    name: 'strategy-form',
    components: {vBtnForm, vStepGenerator},
    data: () => ({
      title: '',
      valid: true,
      model: null
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      parentId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      typeCode: {
        type: String,
        default: null
      },
      strategy: {
        type: Object,
        default: () => new Strategy(this)
      }
    },
    created () {
      // this.updateStrategy(null)
    },
    mounted () {
      // this.updateStrategy(this.typeCode)
      this.strategy.setContext(this)
      this.fetchData(this.itemId)
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        // this.updateStrategy(this.typeCode)
        this.fetchData(this.itemId)
      },
      strategy: function (newVal, oldVal) { // watch it
        // this.updateStrategy(this.typeCode)
        this.strategy = newVal
        this.strategy.setContext(this)
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      }),
      isEdit () {
        return true
      },
      isNew () {
        return this.itemId === null
      }
    },
    methods: {
       // Model methods
      fetchData (itemId) {
        this.strategy.fetchData(itemId).then(data => {
          this.updateModel(this.strategy.createModelFromData(data))
          this.title = this.strategy.viewTitle(this.strategy.createModelFromData(data))
        })
      },
      updateData (model, cb) {
        this.model = model
        this.strategy.updateData(this.itemId, this.model, this.parentId).then(
          (itemId) => {
            this.fetchData(itemId)
            if (cb) {
              cb(itemId)
            }
          })
      },
      updateModel (model) {
        this.$nextTick(() => {
          // console.log('updateModel', model)
          this.model = model
          this.strategy.updateModel(model)
          this.$forceUpdate()
        })
      },
      add () {
        const cb = (data) => {
          this.$emit('change', data)
          this.cancel()
        }
        this.updateData(this.model, cb)
      },
      cancel () {
        // this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      save () {
        const cb = (data) => {
          this.$emit('change', data)
          this.cancel()
        }
        this.updateData(this.model, cb)
      },
      remove () {
        this.strategy.deleteData(this.itemId, this.model).then(() => {
          this.$emit('change', null)
          this.cancel()
        })
      },
      createNew () {
        this.$emit('createNew')
      }
    }
  }

</script>




// WEBPACK FOOTER //
// StrategyForm.vue?d10088d0